package cz.lhoracek.mapl.ui.navigation

sealed class Screen {
    data object Home : Screen()
    data object Rules : Screen()
    data class Session(val sessionId: String) : Screen()
    data object NewSession : Screen()
    data class AddRound(val sessionId: String) : Screen()
}
